@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';

.information {
  padding: 20px;

  .header {
    border-bottom: 1px solid @settings-page--account-user-information--border-color;
    padding-bottom: 10px;
  }

  .body {
    display: flex;
    flex-direction: column;
    margin-top: 20px;

    .main {
      display: flex;
      margin-bottom: 40px;
    }

    .left-section {
      display: grid;
      grid-template-columns: auto auto;
      gap: 10px;
      align-items: center;
    }

    .right-section {
      padding: 0 20px;

      > .date-data {
        height: 50px;
        display: flex;
        flex-direction: column;
        line-height: 1.5;
        margin-bottom: 5px;
      }
    }
  }
}

@headerHeight: 35px;

.email-warning {
  width: 300px;
  font-size: 14px;
  line-height: 1.3;

  .header {
    padding: 10px;
    height: @headerHeight;
    background-color: @settings-page--account-user-information-tootip--background-color;
    border-bottom: 1px solid @settings-page--account-user-information-tootip--border-color;
  }

  .body {
    height: calc(100% - @headerHeight);
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    padding: 10px;

    > button {
      margin-top: 5px;
    }
  }
}

.account-locked {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 200px;

  > button {
    margin-top: 10px;
    width: auto;
  }

  .loading {
    height: 40px;
    width: 40px;
    align-self: center;
  }
}

.ok {
  color: @settings-page--account-user-information--success--text-color;
}
.danger {
  color: @settings-page--account-user-information--danger--text-color;
  min-height: 50px;
}
